import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
    isLastStepSelector,
    activeStepSelector,
    isSummaryActiveStep,
    canFinishSelector,
    isQRActiveStep,
    errorSelector
} from '../selectors/wizardSelectors';
import { changeStep } from '../actions/wizardActions';
import StepNavigator from '../components/StepNavigator/StepNavigator';

const mapStateToProps = createStructuredSelector({
    isLastStep: isLastStepSelector,
    activeStep: activeStepSelector,
    isSummaryActiveStep: isSummaryActiveStep,
    canFinish: canFinishSelector,
    isQRActiveStep,
    error: errorSelector
});

const mapDispatchToProps = { changeStep };

export default withTranslation(['common', 'wizard'])(
    withRouter(
        connect(mapStateToProps, mapDispatchToProps)(StepNavigator)
    )
);
